import { UploadDoctorDocument } from 'domain/usecases/doctor/upload-doctor-document'
import { DoctorRepository } from 'repository/repositories/doctor/doctor-repository'

export class RemoteUploadDoctorDocument implements UploadDoctorDocument {
  private readonly doctorRepository: DoctorRepository

  constructor(doctorRepository: DoctorRepository) {
    this.doctorRepository = doctorRepository
  }
  upload(
    params: UploadDoctorDocument.Params
  ): Promise<UploadDoctorDocument.Model> {
    return this.doctorRepository.uploadDoctorDocument(params)
  }
}
